export var SELECTION_CATEGORY = /*#__PURE__*/function (SELECTION_CATEGORY) {
  SELECTION_CATEGORY["EMPTY"] = "empty";
  SELECTION_CATEGORY["FULL_DOCUMENT"] = "fullDocument";
  SELECTION_CATEGORY["FULL_SINGLE_BLOCK"] = "fullSingleBlock";
  SELECTION_CATEGORY["PARTIAL_SINGLE_BLOCK"] = "partialSingleBlock";
  SELECTION_CATEGORY["FULL_MULTIPLE_BLOCKS"] = "fullMultipleBlocks";
  SELECTION_CATEGORY["PARTIAL_MULTIPLE_BLOCKS"] = "partialMultipleBlocks";
  return SELECTION_CATEGORY;
}({});